import { TrackToolService } from '@analytics/events';
import { AnalyticsActionTypes, type ToolTrackValues } from '@analytics/models';
import { lowerCaseObjectKeys } from '@analytics/utils';
import { Injectable, Injector } from '@angular/core';
import { AnalyticsMapPipe } from '@innogy/utils-deprecated';

import type { CalculateToolstepLaststepResult } from './calculate-toolstep-laststep.model';

@Injectable({
  providedIn: 'root',
})
export class CalculateToolstepLaststepService {
  public readonly trackCalculateLaststep = (
    calculateResultValues: CalculateToolstepLaststepResult
  ) => {
    const trackingValues: ToolTrackValues = {
      step: 1,
      stepName: '',
      type: AnalyticsActionTypes.LAST_STEP,
      rendering: {
        componentName: 'keuzehulp',
      },
    };
    const {
      stroomverbruikJaar,
      stroomverbruikJaarDal,
      stroomverbruikJaarPiek,
      gasverbruikJaar,
      terugleveringJaar,
      bewonersAantal,
      woningType,
      aansluitingType,
    } = calculateResultValues;
    const extraValues = {
      result: lowerCaseObjectKeys({
        stroomverbruikJaar,
        stroomverbruikMaand: this.getMonthlyUsage(stroomverbruikJaar),
        stroomverbruikJaarDal,
        stroomverbruikMaandDal: this.getMonthlyUsage(stroomverbruikJaarDal),
        stroomverbruikJaarPiek,
        stroomverbruikMaandPiek: this.getMonthlyUsage(stroomverbruikJaarPiek),
        gasverbruikJaar,
        gasverbruikMaand: this.getMonthlyUsage(gasverbruikJaar),
        terugleveringJaar,
        terugleveringMaand: this.getMonthlyUsage(terugleveringJaar),
        aantalPersonen: bewonersAantal,
        typeHuis: this.analyticsMap.transform(woningType),
        typeAansluiting: this.analyticsMap.transform(aansluitingType),
      }),
    };

    /**
     * WTA-17: resolve injector context
     */
    const trackToolService = this.injector.get(TrackToolService);

    return trackToolService.trackTool(trackingValues, extraValues);
  };

  constructor(
    private readonly injector: Injector,
    private readonly analyticsMap: AnalyticsMapPipe
  ) {}

  /**
   * Utilities
   */
  private getMonthlyUsage(consumption: number) {
    return Math.floor(consumption / 12);
  }
}
